export default __webpack_public_path__ + "static/media/archetypeaa.a5731d25.png";